export const environment = {
  production: false,
  apiUrl: 'https://taxlink-backend-66674259441.us-central1.run.app/api/v1',
  app: 'COMPLYDESK',
  appId: 'V-00',
  gsClientId: '',
  vatTurnoverThreshold: 25000000,
  paymentCallbackUrl: 'http://localhost:4200/payment/callback',
};
